import { render, staticRenderFns } from "./userGradeDetail.vue?vue&type=template&id=40115d1f&scoped=true&"
import script from "./userGradeDetail.vue?vue&type=script&lang=js&"
export * from "./userGradeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40115d1f",
  null
  
)

export default component.exports